const adelImageMap = {
  "ADEL - 10 Respiratory Drops": "ADEL - 10 Respiratory Drops.jpg",
  "ADEL - 19 MentalPhysical tiredness (General Weakness) Drops":
    "ADEL - 19 MentalPhysical tiredness (General Weakness) Drops.jpg",
  "Adel 1- Headache & Migraine Drops":
    "Adel 1- Headache & Migraine Drops.jpg",
  "Adel 11 - Constipation Drops":
    "Adel 11 - Constipation Drops.jpg",
  "ADEL 12 - Skin Drops": "ADEL 12 - Skin Drops.jpg",
  "ADEL 13 - Weight Management Drops":
    "ADEL 13 - Weight Management Drops.jpg",
  "ADEL 14 - Iron Deficiency Drops":
    "ADEL 14 - Iron Deficiency Drops.png",
  "ADEL 15 - Women’s White Discharge Drops":
    "ADEL 15 - Women’s White Discharge Drops.jpg",
  "ADEL 16 - Gastrointestinal Drops":
    "ADEL 16 - Gastrointestinal Drops.jpg",
  "ADEL 17 - Eye Care Drops":
    "ADEL 17 - Eye Care Drops.jpg",
  "ADEL 18 - Diabetes Management Drops":
    "ADEL 18 - Diabetes Management Drops.jpg",
  "ADEL 2 - Piles & Hemorrhoids Drops":
    "ADEL 2 - Piles & Hemorrhoids Drops.jpg",
  "ADEL 20 - Allergy Drops": "ADEL 20 - Allergy Drops.jpg",
  "ADEL 21 - Prostate Drops": "ADEL 21 - Prostate Drops.jpg",
  "ADEL 22 - Kidney Drops": "ADEL 22 - Kidney Drops.jpg",
  "ADEL 23 - Sinusitis Drops": "ADEL 23 - Sinusitis Drops.jpg",
  "ADEL 24 - Tonsils Drops": "ADEL 24 - Tonsils Drops.jpg",
  "ADEL 25 - Sleep Disorder Drops":
    "ADEL 25 - Sleep Disorder Drops.jpg",
  "ADEL 26 - Osteoarthritis Drops":
    "ADEL 26 - Osteoarthritis Drops.jpg",
  "ADEL 27 - Injury Drops": "ADEL 27 - Injury Drops.jpg",
  "ADEL 28 - Cholesterol Management Drops":
    "ADEL 28 - Cholesterol Management Drops.jpg",
  "ADEL 29 - UTI Drops": "ADEL 29 - UTI Drops.jpg",
  "ADEL 3 - Jaundice & Liver Drops":
    "ADEL 3 - Jaundice & Liver Drops.jpg",
  "ADEL 31 - Periods Regulating (PCOS, PCOD)":
    "ADEL 31 - Periods Regulating (PCOS, PCOD).png",
  "ADEL 32 - Inflammation Drops":
    "ADEL 32 - Inflammation Drops.jpg",
  "ADEL 33 - Oedema Drops": "ADEL 33 - Oedema Drops.jpg",
  "ADEL 34 - Spleen Drops": "ADEL 34 - Spleen Drops.jpg",
  "Adel 36 - Vitality Drops": "Adel 36 - Vitality Drops.jpg",
  "ADEL 38 - Cramp Pain Drops":
    "ADEL 38 - Cramp Pain Drops.jpg",
  "ADEL 39 - Sciatica Drops": "ADEL 39 - Sciatica Drops.jpg",
  "ADEL 4 - Joint Pain Drops": "ADEL 4 - Joint Pain Drops.jpg",
  "ADEL 40 - Warts Drops": "ADEL 40 - Warts Drops.png",
  "ADEL 43 - Heart & Cardiovascular Drops":
    "ADEL 43 - Heart & Cardiovascular Drops.jpg",
  "ADEL 44 - Varicose Veins Drops":
    "ADEL 44 - Varicose Veins Drops.jpg",
  "ADEL 48 - Lymph & Tumour Drops (adjuvant)":
    "ADEL 48 - Lymph & Tumour Drops (adjuvant).jpg",
  "ADEL 49 - Diarrhoea Drops": "ADEL 49 - Diarrhoea Drops.png",
  "Adel 5 - Acidity, Gas & Stomach Drops":
    "Adel 5 - Acidity, Gas & Stomach Drops.jpg",
  "ADEL 50 - Worms Drops": "ADEL 50 - Worms Drops.png",
  "Adel 51 - Anxiety & Stress Drops":
    "Adel 51 - Anxiety & Stress Drops.jpg",
  "ADEL 54 - Heart Care Drops":
    "ADEL 54 - Heart Care Drops.jpg",
  "ADEL 55 - Spondylitis Drops":
    "ADEL 55 - Spondylitis Drops.png",
  "ADEL 56 - Immune System Drops":
    "ADEL 56 - Immune System Drops.jpg",
  "ADEL 57 - Digestion Drops":
    "ADEL 57 - Digestion Drops.png",
  "ADEL 6 - Thyroid Management Drops":
    "ADEL 6 - Thyroid Management Drops.jpg",
  "ADEL 61 - Adrenal Gland Drops":
    "ADEL 61 - Adrenal Gland Drops.jpg",
  "ADEL 64 - Uric Acid Drops":
    "ADEL 64 - Uric Acid Drops.png",
  "ADEL 65 - Body Temperature Management Drops":
    "ADEL 65 - Body Temperature Management Drops.png",
  "ADEL 66 - Detoxification Drops":
    "ADEL 66 - Detoxification Drops.jpg",
  "ADEL 69 - Circulatory Drops":
    "ADEL 69 - Circulatory Drops.jpg",
  "ADEL 7 - Cough Drops": "ADEL 7 - Cough Drops.jpg",
  "ADEL 73 - Anti-fungal Drops":
    "ADEL 73 - Anti-fungal Drops.jpg",
  "ADEL 75 - Pain Relief Ointment":
    "ADEL 75 - Pain Relief Ointment.png",
  "ADEL 78 - Skin Ointment":
    "ADEL 78 - Skin Ointment.png",
  "ADEL 79 - Iron Tonic": "ADEL 79 - Iron Tonic.jpg",
  "ADEL 8 - Blood Pressure Management Drops":
    "ADEL 8 - Blood Pressure Management Drops.jpg",
  "ADEL 82 - Liver Tonic": "ADEL 82 - Liver Tonic.png",
  "ADEL 83 - Cough Syrup": "ADEL 83 - Cough Syrup.jpg",
  "ADEL 85 - Energy Drops": "ADEL 85 - Energy Drops.png",
  "ADEL 85 - Vitality Tonic":
    "ADEL 85 - Vitality Tonic.jpg",
  "ADEL 86 - Warts (External)":
    "ADEL 86 - Warts (External).jpg",
  "ADEL 87 - Infection Drops":
    "ADEL 87 - Infection Drops.png",
  "ADEL 9 - Hair Care Drops":
    "ADEL 9 - Hair Care Drops.jpg",
};const schwabe5ImageMap = {
  "Gastrobin": "Gastrobin.webp",
  "Essentia Aurea": "Essentia_Aurea.jpg",
  "Diacard": "Diacard.webp",
  "Biofungin": "Biofungin.png",
  "Bryorheum": "Bryorheum.jpg",
};const schwabeImageMap = {
  // Soaps
  "B&T Glow & Fairness Soap": ["Soaps", "B&T Glow & Fairness Soap.jpg"],
  "B&T Akne-Sor Soap": ["Soaps", "B&T Akne - Sor Soap.jpg"],

  // Ointments
  "Heal Plus Cream": ["Ointments", "Heal Plus Cream.jpg"],
  "Topi Azadirachta Cream": ["Ointments", "Topi Azadirachta Cream.jpg"],
  "Ruck Pain Gel": ["Ointments", "Ruck Pain Gel.jpg"],

  // Eye & Ear Drops
  "Cineraria Maritima Schwabe Eye Drops": [
    "Eye_Ear_Drops",
    "Cineraria_Maritima_Schwabe_Eye_Drops.jpg",
  ],

  // Liquid Specialities
  "ALPHA-LIV SUGAR FREE": [
    "Liquid_Specialities",
    "ALPHA-LIV SUGAR FREE.jpg",
  ],
  "Lilium tigr. Pentarkan": [
    "Liquid_Specialities",
    "Lilium tigr. Pentarkan.jpg",
  ],
  "Dizester": ["Liquid_Specialities", "Dizester.jpg"],
  "Hertone": ["Liquid_Specialities", "Hertone.jpg"],
  "Gnaphalium Pentarkan": [
    "Liquid_Specialities",
    "Gnaphalium Pentarkan®.jpg",
  ],
  "Alpha-Liv-Drops": ["Liquid_Specialities", "Alpha-Liv-Drops.png"],
  "Zauber Hair Drops": ["Liquid_Specialities", "Zauber Hair Drops.jpg"],
  "Good Morning": ["Liquid_Specialities", "Good Morning.jpg"],

 // Skin Care

"B&T Nourish collection Body Lotion": [
  "Skin_Care",
  "B&T Nourish collection Body Lotion.jpg",
],
 "B&T Nourish Collection Body Wash": [
   "Skin_Care",
 "B&T Nourish Collection Body Wash.jpg",
  ],
  "B&T Foot Cream": ["Skin_Care", "B&T Foot Cream.jpg"],
  "B&T NOURISH COLLECTION SPF 50 SUNSCREEN": [
"Skin_Care",
 "B&T NOURISH COLLECTION SPF 50 SUNSCREEN.jpg",
  ],
  "B&T Nourish Collection Face Wash": [
"Skin_Care",
    "B&T Nourish Collection Face Wash.jpg",
  ],
  "B&T Aloe Vera Gel 100GM": [
"Skin_Care",
    "B&T Aloe Vera Gel 100GM.jpg",
  ],
  "B&T NOURISH COLLECTION SKIN RADIANCE CREAM": [
"Skin_Care",
    "B&T NOURISH COLLECTION SKIN RADIANCE CREAM.jpg",
  ],
  "B&T Aloe Vera Cream": ["Skin_Care", "B&T Aloe Vera Cream.jpg"],

  // Tablet Specialities
  "Guatteria gaumeri 1x": [
    "Tablet_Specialities",
    "Guatteria gaumeri 1x.jpg",
  ],
  "Baptisia tinctoria 1X MT tabs": [
    "Tablet_Specialities",
    "Baptisia tinctoria 1X MT tabs.jpg",
  ],
  "Fucus vesiculosus 1x MT Tabs": [
    "Tablet_Specialities",
    "Fucus vesiculosus 1x MT Tabs.jpg",
  ],
  "Crataegus oxyacantha 1x MT tabs": [
    "Tablet_Specialities",
    "Crataegus oxyacantha 1x MT tabs.jpg",
  ],
  "Sabal serrulata 1x MT Tabs": [
    "Tablet_Specialities",
    "Sabal serrulata 1x MT Tabs.jpg",
  ],
  "Ginkgo biloba 1X": [
    "Tablet_Specialities",
    "Ginkgo biloba 1X.jpg",
  ],

  // Hair Care
  "B&T 7oL": ["Hair_Care", "Bu0026T 7oL.jpg"],
  "B&T Anti-Dandruff Oil": [
    "Hair_Care",
    "Bu0026T Anti-Dandruff Oil.jpg",
  ],
  "B&T Arnica Shampoo 2 in 1": [
    "Hair_Care",
    "B u0026 T Arnica Shampoo 2 in 1.webp",
  ],
  "B&T Hair Serum": ["Hair_Care", "Bu0026T Hair Serum.jpg"],
  "B&T Anti-Dandruff Shampoo": [
    "Hair_Care",
    "Bu0026T Anti- Dandruff Shampoo.jpg",
  ],
  "B&T Arnica Shampoo": [
    "Hair_Care",
    "Bu0026T Arnica Shampoo.jpg",
  ],
  "B&T Hair Growth Oil": [
    "Hair_Care",
    "Bu0026T Hair Growth Oil.jpg",
  ],
  "Zauberöl - Premium Hair Growth Oil": [
    "Hair_Care",
    "Zauberöl - Premium Hair Growth Oil.jpg",
  ],
 "B&T Nourish Collection Repair & Shine Shampoo": [
    "Hair_Care",
    "Bu0026T Nourish Collection Repair u0026 Shine Shampoo.jpg",
  ],
};const getMedicineImage = (
  med,
  tab,
  small = false
) => {
  let image = `/images/Dilutions/${med}.jpeg`;


if (tab === "Biochemic") {
  if (med.startsWith("SBL ")) {
    const sblMed = med.replace("SBL ", "");
    image = `/images/SBL/Biochemic/${sblMed}.jpg`;
  } else {
    image = `/images/Biochemic/${med}.jpeg`;
  }
}

if (tab === "BC") {
  let bcImage;

  if (med.startsWith("SBL BC ")) {
    const bcNumber = med.replace("SBL BC ", "");

    if (bcNumber === "26" || bcNumber === "27") {
      bcImage = `/images/SBL/BC/Bio-Combination ${bcNumber}.png`;
    } else {
      bcImage = `/images/SBL/BC/Bio-Combination ${bcNumber}.jpg`;
    }
  } else {
    bcImage = `/images/BC/${med}.jpeg`;
  }

  return (
    <div
      style={{
        height: small ? "120px" : "240px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <img
        src={bcImage}
        alt={med}
        style={{
          height: small ? "100px" : "220px",
          objectFit: "contain",
        }}
      />
    </div>
  );
}

if (tab === "Mother Tincture") {
  return (
    <div
      style={{
        height: small ? "120px" : "240px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <img
        src={`/images/MotherTincture/${med}.jpeg`}
        alt={med}
        style={{
          height: small ? "100px" : "220px",
          objectFit: "contain",
        }}
      />
    </div>
  );
}

if (tab === "R Drops") {
  return (
    <div
      style={{
        height: small ? "120px" : "240px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <img
src={`/images/rdrops/${med.replace(/\s/g, "")}.jpeg`}
        alt={med}
        style={{
          height: small ? "100px" : "220px",
          objectFit: "contain",
        }}
      />
    </div>
  );
}
if (tab === "SBL Liquid Specialities") {
  const filename = encodeURIComponent(med);

  return (
    <div
      style={{
        height: small ? "120px" : "240px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <img
        src={`/images/SBL%20Specialities/Liquid%20Specialities/${filename}.jpg`}
        alt={med}
        style={{
          height: small ? "100px" : "220px",
          objectFit: "contain",
        }}
        onError={(e) => {
          // Calendula Spray is PNG
          if (med === "Calendula Spray") {
            e.currentTarget.src =
              `/images/SBL%20Specialities/Liquid%20Specialities/Calendula%20Spray.png`;
          }
        }}
      />
    </div>
  );
}

if (tab === "Health") {
  const adelImage = adelImageMap[med];

  if (adelImage) {
    return (
      <div
        style={{
          height: small ? "120px" : "240px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <img
          src={`/images/ADEL_Images/${encodeURIComponent(adelImage)}`}
          alt={med}
          style={{
            height: small ? "100px" : "220px",
            objectFit: "contain",
          }}
        />
      </div>
    );
  }

  const schwabe5Image = schwabe5ImageMap[med];

  if (schwabe5Image) {
    return (
      <div
        style={{
          height: small ? "120px" : "240px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <img
          src={`/images/Schwabe_5/${encodeURIComponent(schwabe5Image)}`}
          alt={med}
          style={{
            height: small ? "100px" : "220px",
            objectFit: "contain",
          }}
        />
      </div>
    );
  }
  const schwabeImage = schwabeImageMap[med];

  if (schwabeImage) {
    const [folder, filename] = schwabeImage;

    return (
      <div
        style={{
          height: small ? "120px" : "240px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <img
          src={`/images/Schwabe_India_Images/${encodeURIComponent(
            folder
          )}/${encodeURIComponent(filename)}`}
          alt={med}
          style={{
            height: small ? "100px" : "220px",
            objectFit: "contain",
          }}
        />
      </div>
    );
  }
 let folder = "";
  let extension = "jpg";

  const eyeEar = [
    "Euphrasia 10% Eye Drops",
    "Cineraria Maritima 10% Eye Drops",
    "Mullein Ear Drops",
    "Cineraria Maritima Euphrasia Eye Drops",
  ];

  const hairCare = [
    "SBL Jaborandi Plus Hair Oil (Mineral Oil Free)",
    "SBL Drops No.1",
    "Arnica Montana Herbal Shampoo with Conditioner Com....",
    "Arnica Montana Fortified Hair Oil (Mineral Oil Fre....",
    "Scalptone Tablets",
    "Jaborandi Anti-Dandruff Shampoo",
  ];

  const skinCare = [
    "Sulphur Ointment",
    "Babchi Oil",
    "Sulphur Gel",
    "Urtica Urens Ointment",
    "Thuja Ointment",
    "Cardiospermum Helicacabum Ointment",
    "Thuja Gel",
    "Echinacea Ointment",
    "Petroleum Ointment",
  ];

  const ointments = [
    "Orthomuv Ointment",
    "Funginil Cream",
    "Hypericum Ointment",
    "Hamamelis Ointment",
    "Rhustox Ointment",
    "Rhustox Gel",
    "Graphites Ointment",
    "Graphites Gel",
    "Ruta Ointment",
    "Orthomuv Gel",
  ];

  if (eyeEar.includes(med)) {
    folder = "SBL EyeEarDrops";
  } else if (hairCare.includes(med)) {
    folder = "SBL Haircare";
  } else if (skinCare.includes(med)) {
    folder = "SBL Skincare";
  } else if (ointments.includes(med)) {
    folder = "SBL_Ointments";
  }

  return (
    <div
      style={{
        height: small ? "120px" : "240px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <img
        src={`/images/SBL%20Specialities/${encodeURIComponent(folder)}/${encodeURIComponent(med)}.${extension}`}
        alt={med}
        style={{
          height: small ? "100px" : "220px",
          objectFit: "contain",
        }}
      />
    </div>
  );
}
  return (

    <div
      style={{
        position: "relative",
        height:
        small
        ? "120px"
        : "240px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
      }}
    >

      <img
        src={image}
        alt={med}
        style={{
          height:
          small
          ? "100px"
          : "220px",
          objectFit: "contain"
        }}
      />
    </div>
  );
};

export default getMedicineImage;